const styles = {
  searchContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '1rem',
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 12px rgba(10, 16, 68, 0.08)',
    mb: 2,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    width: '100%',
  },
  firstLine: (responsive: boolean) => ({
    display: 'flex',
    flexDirection: responsive ? ('column' as const) : ('row' as const),
    alignItems: responsive ? ('stretch' as const) : ('center' as const),
    flexWrap: 'nowrap' as const,
    width: '100%',
    gap: '0.5rem',
  }),
  field: (responsive: boolean) => ({
    flex: responsive ? undefined : '0 1 220px',
    minWidth: responsive ? '100%' : 0,
    maxWidth: responsive ? '100%' : '220px',
  }),
  actionsContainer: (responsive: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    height: responsive ? 'auto' : '49px',
    flexShrink: 0,
    justifyContent: responsive ? 'flex-end' : 'flex-start',
    ml: responsive ? 0 : 'auto',
  }),
  clearButton: {
    box: {
      alignSelf: 'center',
    },
    button: {
      color: 'primary.main',
      fontSize: '0.75rem',
      padding: '1rem 0.5rem',
      whiteSpace: 'nowrap',
    },
  },
};

export default styles;
